<template>
  <div class="flex flex-col mt-2">
    <div class="relative flex items-center mt-4">
      <input
        v-model="searchString"
        type="text"
        class="flex-1 bg-almost-black text-honestly-white py-3 px-2 outline-none"
      />
      <i class="fas fa-search absolute text-h3 right-0 mr-2"></i>
    </div>
    <div class="flex flex-col">
      <span v-if="searchString != '' && matchingItems.length === 0" class="mt-2">
        Our minions didn't find any result for “{{ searchString }}”
      </span>
      <faq-item
        v-for="item in matchingItems"
        :key="item.id"
        :question="item.question"
        :answer="item.answer"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchString: '',
      items: window['faq-categories'].reduce(
        (items, category) => [...items, ...category.items],
        []
      ),
    };
  },

  computed: {
    matchingItems() {
      if (!this.searchString) {
        return [];
      }

      return this.items
        .filter(
          ({ question }) =>
            question.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        )
        .slice(0, 5);
    },
  },
};
</script>
